const LEGACY_MAPPING = {
  excited:  { x: 0.25, y: 0.25 },
  stressed: { x: 0.75, y: 0.25 },
  content:  { x: 0.25, y: 0.75 },
  calm:     { x: 0.25, y: 0.75 },
  drained:  { x: 0.75, y: 0.75 },
}

// Dial format (angle/intensity) → grid format (x/y)
function migrateDialFormat(raw) {
  const angle = raw.angle
  const intensity = raw.intensity
  const rad = ((angle - 90) * Math.PI) / 180
  const x = 0.5 + (intensity * Math.cos(rad)) * 0.5
  const y = 0.5 + (intensity * Math.sin(rad)) * 0.5
  return {
    x: Math.max(0, Math.min(1, x)),
    y: Math.max(0, Math.min(1, y)),
  }
}

export function migrateMoodCompassData(raw) {
  if (!raw) return null

  // Grid format: { x, y } as integer percent (0-100). Decoded to floats
  // (0-1) for the renderer and interpretation helpers. Integers are used
  // on the wire so the backend can serialize them to DynamoDB (boto3's
  // resource API rejects Python floats).
  if (typeof raw === 'object' && typeof raw.x === 'number' && typeof raw.y === 'number') {
    return {
      x: Math.max(0, Math.min(1, raw.x / 100)),
      y: Math.max(0, Math.min(1, raw.y / 100)),
    }
  }

  // Dial format: { angle, intensity }
  if (typeof raw === 'object' && raw !== null && 'angle' in raw && 'intensity' in raw) {
    return migrateDialFormat(raw)
  }

  // Legacy string format: { value: "excited" } or just "excited"
  const legacyValue = typeof raw === 'string' ? raw : raw.value
  if (legacyValue && LEGACY_MAPPING[legacyValue]) {
    return { ...LEGACY_MAPPING[legacyValue] }
  }

  return null
}
